import $ from "jquery";

$(document).on("click", '[data-js="jsCollapseTitle"]', function () {
  const $title = $(this);
  const $body = $(`#${$title.attr("aria-controls")}`);
  const isExpanded = $title.attr("aria-expanded") === "true";
  if (isExpanded) {
    $body.attr("hidden", "hidden");
  } else {
    $body.removeAttr("hidden");
  }
  $title.attr("aria-expanded", !isExpanded);
});

$(function () {
  // TODO: move to separate component
  // TODO: add debounce on resize
  if (window.matchMedia("(max-width: 991.98px)").matches) {
    // Collapse search filters on mobile load
    $('[data-js="jsSearchFilterCollapse"] [data-js="jsCollapseBody"]').attr(
      "hidden",
      "hidden",
    );
    $('[data-js="jsSearchFilterCollapse"] [data-js="jsCollapseTitle"]').attr(
      "aria-expanded",
      false,
    );
  }
});
